import { useMemo } from 'react';

/**
 * Mock data for the Explore page (Tangor frontend)
 * This data matches the structure from usePoolsInfo but is static/fake
 */

export type ExplorePoolData = {
  poolId: string;
  name: string;
  baseSymbol: string;
  quoteSymbol: string;
  tvlNotional: number;
  aprPercentage: number;
  volume24hNotional: number;
  fees24hNotional: number;
  baseIconUrl?: string;
  quoteIconUrl?: string;
};

export type ExploreSummaryData = {
  totalVolume: number;
  totalVolumeChange: number;
  volume24h: number;
  tvl: number;
  tvlChange: number;
};

// Mock pool data matching the Figma design
const MOCK_POOLS: ExplorePoolData[] = [
  {
    poolId: '1',
    name: 'tAPPL/USDC',
    baseSymbol: 'tAPPL',
    quoteSymbol: 'USDC',
    tvlNotional: 2_153_235.82,
    aprPercentage: 1.2,
    volume24hNotional: 182_209.4,
    fees24hNotional: 182_209.4,
  },
  {
    poolId: '2',
    name: 'tTSLA/USDC',
    baseSymbol: 'tTSLA',
    quoteSymbol: 'USDC',
    tvlNotional: 3_153_598.71,
    aprPercentage: 4.92,
    volume24hNotional: 53_304.2,
    fees24hNotional: 53_304.2,
  },
  {
    poolId: '3',
    name: 'tNVDA/USDC',
    baseSymbol: 'tNVDA',
    quoteSymbol: 'USDC',
    tvlNotional: 202_394.203,
    aprPercentage: 2.61,
    volume24hNotional: 33_457.37,
    fees24hNotional: 33_457.37,
  },
  {
    poolId: '4',
    name: 'tMETA/USDC',
    baseSymbol: 'tMETA',
    quoteSymbol: 'USDC',
    tvlNotional: 128_390.3,
    aprPercentage: 0.66,
    volume24hNotional: 27_000.0,
    fees24hNotional: 27_000.0,
  },
  {
    poolId: '5',
    name: 'EURC/USDC',
    baseSymbol: 'EURC',
    quoteSymbol: 'USDC',
    tvlNotional: 64_302.23,
    aprPercentage: 0.02,
    volume24hNotional: 4_127.88,
    fees24hNotional: 4_127.88,
  },
  {
    poolId: '6',
    name: 'ETH/USDC',
    baseSymbol: 'ETH',
    quoteSymbol: 'USDC',
    tvlNotional: 64_302.23,
    aprPercentage: 0.02,
    volume24hNotional: 0.02,
    fees24hNotional: 4_127.88,
  },
  {
    poolId: '7',
    name: 'cbBTC/ETH',
    baseSymbol: 'cbBTC',
    quoteSymbol: 'ETH',
    tvlNotional: 64_302.23,
    aprPercentage: 0.02,
    volume24hNotional: 0.02,
    fees24hNotional: 4_127.88,
  },
  {
    poolId: '8',
    name: 'cbBTC/USDC',
    baseSymbol: 'cbBTC',
    quoteSymbol: 'USDC',
    tvlNotional: 64_302.23,
    aprPercentage: 0.02,
    volume24hNotional: 0.02,
    fees24hNotional: 4_127.88,
  },
  {
    poolId: '9',
    name: 'EURC/USDC',
    baseSymbol: 'EURC',
    quoteSymbol: 'USDC',
    tvlNotional: 64_302.23,
    aprPercentage: 0.02,
    volume24hNotional: 0.02,
    fees24hNotional: 4_127.88,
  },
];

// Mock summary data matching the Figma design
const MOCK_SUMMARY: ExploreSummaryData = {
  totalVolume: 33_320_000,
  totalVolumeChange: 2.32,
  volume24h: 4_900_000,
  tvl: 24_400_000,
  tvlChange: 2.32,
};

/**
 * Hook to get mock explore data
 * This mimics the structure of usePoolsInfo but returns static data
 */
export function useExploreData() {
  const pools = useMemo(() => MOCK_POOLS, []);
  const summary = useMemo(() => MOCK_SUMMARY, []);

  return {
    pools,
    summary,
    isLoading: false,
  };
}
